module.exports = __webpack_public_path__ + "img/liyongge.94811b8e.jpg";